import React from 'react'
import KamronHeader from './KamronHeader'
import {KamronSingle} from './KamronSingle'

const Kamron = ({open}) => {
  return (
    <div>
        <KamronHeader/>
        <KamronSingle open={open}/>
    </div>
  )
}

export default Kamron